<template>
  <v-container fluid>
    <DateTimePicker
      :defaultRange="dateTime.range"
      :range="true"
      v-model="dateTime"
      :initStartDate="start"
      :initEndDate="end"
      @submit="getAllLocations"
    />

    <v-expansion-panels popout class="mt-2">
      <v-expansion-panel class="rounded-xl glass-card" 
        v-for="(location, i) in locations"
        :key="location.id || i"
      >
        <v-expansion-panel-header>
          {{ location.name }}
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-card flat class="rounded-xl" outlined>
            <SaleBaseTileMini
                ref="saleBaseTile"
                :dateTime="dateTime"
                :id="location.id"
              />
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import DateTimePicker from "@/components/DateTimePicker";
import SaleBaseTileMini from "@/modules/Location/components/SaleBaseMini.vue";

export default {
  name: "Home",
  components: {
    DateTimePicker,
    SaleBaseTileMini,
  },
  data() {
    const startOfDay = this.$moment().startOf("day");
    const endOfDay = this.$moment().endOf("day");

    return {
      user: null,
      locations: [],
      start: startOfDay,
      end: endOfDay,
      dateTime: {
        range: "toDay",
        start: startOfDay.toISOString(),
        end: endOfDay.toISOString(),
      },
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
  },
  methods: {
    getAllLocations() {
      if (!this.user || !this.user.Organizations) {
        console.warn("⚠️ No user or organizations found");
        return [];
      }

      const allLocations = this.user.Organizations.flatMap((org) =>
        (org.Locations || []).map((location) => ({
          ...location,
          Organization: {
            id: org.id,
            name: org.name,
          },
        }))
      );

      this.locations = allLocations;
      console.log("Locations loaded:", this.locations);
    },
  },
  created() {
    console.log("🏠 Home component created");
    this.user = this.currentUser;
    this.getAllLocations();
  },
};
</script>